import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";
import { isEmpty } from "lodash";

const fetchAlumni = async (data) => {
  return await axios.get(
    API_URL +
      `/api/Alumni/GetAllAlumni/${data?.pageSize}/${data?.pageNumber}${
        !isEmpty(data?.searchKey) ? "?SearchBy=" + data?.searchKey : ""
      }`,
    {
      headers: securityHeaders,
    }
  );
};

const fetchAmbassadors = async (searchKey) => {
  return await axios.get(
    API_URL +
      `/api/Alumni/GetAlumniAmbassadors${
        !isEmpty(searchKey) ? "?SearchBy=" + searchKey : ""
      }`,
    {
      headers: securityHeaders,
    }
  );
};

const fetchAlumniSuccessStories = async (searchKey) => {
  return await axios.get(
    API_URL +
      `/api/Alumni/GetAlumniSuccessStories${
        !isEmpty(searchKey) ? "?SearchBy=" + searchKey : ""
      }`,
    {
      headers: securityHeaders,
    }
  );
};

const fetchAlumniEvents = async () => {
  return await axios.get(API_URL + `/api/Alumni/`, {
    headers: securityHeaders,
  });
};

const fetchGraduationBatch = async () => {
  return await axios.get(API_URL + `/api/Alumni/GetGraduationBatch`, {
    headers: securityHeaders,
  });
};

const fetchStoryById = async (id) => {
  return await axios.get(
    API_URL + `/api/Alumni/GetAlumniSuccessStoriesById/${id}`,
    {
      headers: securityHeaders,
    }
  );
};

const fetchAmbassadorById = async (id) => {
  return await axios.get(API_URL + `/api/Alumni/GetAlumniAmbassadors/${id}`, {
    headers: securityHeaders,
  });
};

const fetchAlumniStudentById = async (id) => {
  return await axios.get(`${API_URL}/api/Alumni/GetAllAlumniById/${id}`, {
    headers: securityHeaders,
  });
};
const deleteAmbassador = (id) => {
  return axios.post(
    API_URL + `/api/Alumni/DeleteAlumniAmbassador/${id}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

const deleteStory = (id) => {
  return axios.post(
    API_URL + `/api/Alumni/DeleteAlumniSuccessStories/${id}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

const deleteAlumniStudent = (id) => {
  return axios.post(
    API_URL + `/api/Alumni/DeleteAlumni?AlumniId=${id}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchAlumni = (data) => {
  return useQuery({
    queryKey: ["alumni"],
    queryFn: () => fetchAlumni(data),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchStoryById = (id) => {
  return useQuery({
    queryKey: [`successStory-${id}`],
    queryFn: () => fetchStoryById(id),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchAmbassadorById = (id) => {
  return useQuery({
    queryKey: [`ambassador-${id}`],
    queryFn: () => fetchAmbassadorById(id),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchAlumniSuccessStories = (searchKey) => {
  return useQuery({
    queryKey: ["successStories"],
    queryFn: () => fetchAlumniSuccessStories(searchKey),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchAmbassadors = (searchKey) => {
  return useQuery({
    queryKey: ["ambassadors"],
    queryFn: () => fetchAmbassadors(searchKey),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchAlumniEvents = () => {
  return useQuery({
    queryKey: ["alumniEvents"],
    queryFn: () => fetchAlumniEvents(),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchGraduationBatch = () => {
  return useQuery({
    queryKey: ["graduationBatch"],
    queryFn: () => fetchGraduationBatch(),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchAlumniStudentById = (id) => {
  return useQuery({
    queryKey: [`student-${id}`],
    queryFn: () => fetchAlumniStudentById(id),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useDeleteAmbassador = (id) => {
  return useMutation(() => deleteAmbassador(id));
};

export const useDeleteStory = (id) => {
  return useMutation(() => deleteStory(id));
};

export const useDeleteAlumniStudent = (id) => {
  return useMutation(() => deleteAlumniStudent(id));
};
